var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nuxt-link',{staticClass:"IconLink",attrs:{"to":_vm.link,"tag":_vm.tag,"event":_vm.disableClick ? '' : 'click'}},[_c('svgicon',{class:_vm.iconClass,attrs:{"icon":_vm.icon,"fill":""}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }